import Component from './UpdateSimple.vue';

export default {
  install(Vue) {
    Vue.component('BkfDialogFormSimple', Component);
  },
};
